export default __webpack_public_path__ + "static/media/86t.f742bcad.jpg";